<!-- eslint-disable vue/no-template-shadow -->
<template>
  <div
    id="modal_pay_for_plan"
    class="modal modal-right fade"
    data-backdrop="static"
    role="dialog"
  >
    <!-- <div> -->
    <div
      v-if="!isModalSuccess"
      class="modal-dialog modal-xl"
    >
      <div
        v-show="!isSelectAddress"
        class="modal-content"
        style="color: #333;"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("Purchase Subscription Plan") }}
          </h6>
          <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close"> -->
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
            ref="close"
            @click="closeModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <template v-if="!showBankTransfer && !showQrCode">
          <template v-if="isLoading">
            <div class="p-3">
              <PlaceholderContent is-load="true" />
            </div>
          </template>
          <template v-if="!isLoading && !hasPermission">
            <div class="p-3">
              <access-denied />
            </div>
          </template>
          <template v-if="!isLoading && hasPermission">
            <div
              class="modal-body"
              style="height: calc(100% - 49px)"
            >
              <div class="row h-100">
                <div class="col-md-8 h-100">
                  <div
                    style="overflow-y: auto"
                    class="h-100"
                  >
                    <div class="card border-light">
                      <div class="card-header bg-light-f6f6f6 border-0 py-2">
                        <div class=" h3 card-title d-flex align-items-center font-weight-bold">
                          <span class="badge mr-2 step-num"> 1 </span>
                          {{ $t("Select Subscription Period") }}
                        </div>
                      </div>

                      <div class="card-body pt-2">
                        <div
                          v-for="plan in plans"
                          @click="selectPlans(plan)"
                          :key="plan.id"
                          :class="['d-flex justify-content-between align-items-center position-relative mt-3 p-3 rounded border pointer',selectPlan.invoice_period == plan.invoice_period ? 'border-primary' : '', ]"
                        >
                          <div>
                            <div class="text-muted text-capitalize">
                              {{ $t(plan.group_name + ' ' + plan.serie_name + ' ' + 'Plan') }}
                            </div>
                            <div class="h6 mb-0">
                              <span class="font-weight-semibold">
                                {{ ((plan.invoice_period >= 12 ? plan.invoice_period / 12 : plan.invoice_period)) + " " + ((12 > plan.invoice_period) ? $t('Monthly') : $t('Yearly')) }}
                              </span>
                              ({{
                                "฿" +
                                  formatNumber(selectCoupon == null ? plan.price / plan.invoice_period * (1 - plan.percent_discount/100) : plan.price / plan.invoice_period) +
                                  (plan.invoice_period > 1 ? " X " + plan.invoice_period + " " +  $t("months") : " " + $t("per month"))
                              }})
                            </div>
                          </div>
                          <div class="h6 mb-0 font-weight-semibold text-right">
                            ฿{{  formatNumber(selectCoupon == null? plan.price - plan.discount: plan.price) }}
                            <span
                              v-if="plan.discount > 0 && selectCoupon == null"
                              class="d-block badge bg-success-400 font-weight-light px-2"
                            >
                              ({{ $t("_Order.Save") }}
                              ฿{{ plan.discount | formatNumber }})
                            </span>
                          </div>
                          <span
                            v-if="
                              selectPlan.invoice_period == plan.invoice_period
                            "
                            class="select-plan"
                          >
                            <i class="fa-solid fa-check" />
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="card border-light">
                      <div class="card-header bg-light-f6f6f6 border-0 py-2">
                        <div
                          class="h3 card-title d-flex align-items-center font-weight-bold">
                          <span class="badge mr-2 step-num"> 2 </span>
                          {{ $t("Billing Preferences") }}
                        </div>
                      </div>
                      <div class="card-body">
                        <TaxInvoice ref="billing_preferences" />
                      </div>
                    </div>
                    <div
                      class="card border-light"
                      v-if="ordersSummary.grandTotal > 0"
                    >
                      <div class="card-header bg-light-f6f6f6 border-0 py-2">
                        <div class=" h3 card-title d-flex align-items-center font-weight-bold">
                          <span class="badge mr-2 step-num"> 3 </span>
                          {{ $t("Payment Method") }}
                        </div>
                      </div>

                      <div class="card-body pb-0">
                        <PaymentMethod
                          @selectPayment="selectPaymentMethod"
                          :pay-amount="ordersSummary.grandTotal"
                          :payment-method-data="paymentMethodData"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4 h-100">
                  <div class="card bg-light-f6f6f6 border-0 h-100">
                    <div class="card-header bg-light-f6f6f6 border-0 py-2">
                      <div
                        class="
                          h3
                          card-title
                          d-flex
                          align-items-center
                          font-weight-bold
                        "
                      >
                        <span class="badge mr-2 step-num">
                          {{ ordersSummary.grandTotal > 0 ? "4" : "3" }}
                        </span>
                        {{ $t("Orders Summary") }}
                      </div>
                    </div>

                    <div class="card-body">
                      <!-- Coupon -->
                      <div class="form-group border-bottom pb-3 mb-0">
                        <label>{{ $t("Coupon Code") }}</label>
                        <div class="d-flex align-items-center">
                          <div class="input-group">
                            <input
                              v-model="couponCode"
                              :placeholder="$t('Enter coupon code') + '...'"
                              type="text"
                              :class="[
                                'form-control',
                                isSearching ? 'border-right-0' : '',
                              ]"
                            >
                            <span
                              v-if="isSearching"
                              class="input-group-prepend"
                            >
                              <span
                                class="
                                  input-group-text
                                  bg-white
                                  border-left-0
                                  px-2
                                "
                              >
                                <i class="icon-spinner2 spinner" />
                              </span>
                            </span>
                            <span
                              v-if="isClearCouponCode"
                              class="cursor-pointer font-size-lg input-group-prepend position-absolute text-grey"
                              @click="clearDataCoupon()"
                              style="right: 10px; top: 11px;"
                            >
                              <i class="fa-solid fa-circle-xmark" />
                            </span>
                          </div>
                          <button
                            @click="searchCoupon()"
                            type="button"
                            class="btn btn-primary ml-2"
                          >
                            {{ $t("Apply") }}
                          </button>
                        </div>
                        <p
                          v-if="invalidCoupon"
                          class="validation-invalid-label"
                        >
                          {{ $t(responseCouponMessage) }}
                        </p>
                        <p
                          v-if="usedCoupon"
                          class="text-success"
                        >
                          <i class="fas fa-check-circle mr-1" />{{ $t("Coupon codes can be used.") }}
                        </p>

                        <!-- style="height: 300px; overflow-y: auto;" -->
                        <div v-if="coupons.length > 0">
                          <dl
                            class="h6 mb-0 mt-2"
                            style="font-size: 13px"
                          >
                            <dd>{{ $t("My Coupons") }}</dd>
                            <dt>
                              {{ coupons.length + " " + $t("Coupons") }}
                            </dt>
                          </dl>
                          <div style="overflow-y: scroll; height: 210px; overflow-x: hidden;">
                            <div
                              v-for="coupon in coupons"
                              :key="coupon.id"
                              @click="clickCoupon(coupon)"
                              class="mb-1"
                            >
                              <div class="d-flex">
                                <div
                                  :class="[
                                    'pl-3',
                                    !coupon.canUse
                                      ? 'bg-coupon-disabled'
                                      : 'bg-coupon',
                                  ]"
                                />
                                <div
                                  :class="[
                                    'pr-3 d-flex align-items-center',
                                    !coupon.canUse
                                      ? 'coupon-disabled'
                                      : 'bg-primary',
                                  ]"
                                >
                                  <span>{{ $t("Discount") }}</span>
                                </div>
                                <div
                                  :class="[
                                    'border border-left-0 flex-fill py-2 rounded-right  position-relative',
                                    selectCoupon == coupon.id
                                      ? 'border-primary bg-blue-custom'
                                      : 'bg-white',
                                  ]"
                                >
                                  <span
                                    v-if="selectCoupon == coupon.id"
                                    class="select-coupon"
                                  >
                                    <i class="fa-solid fa-check" />
                                  </span>
                                  <!-- <button
                                    @click="discountValue = 10"
                                    class="btn btn-outline-primary btn-sm float-right"
                                >
                                    ใช้โค้ด
                                </button> -->

                                  <div
                                    v-if="checkPromotionTypePlanSubscription(coupon)"
                                    :class="['uniform-choice text-primary float-right d-none', selectCoupon == coupon.id ? 'border-primary' : '']"
                                  >
                                    <span
                                      :class="[selectCoupon == coupon.id ? 'checked' : '']"
                                    >
                                      <input
                                        type="radio"
                                        name="check-payment"
                                        class="form-check-input-styled-primary"
                                        :checked="[selectCoupon == coupon.id ? 'checked' : '']"
                                      >
                                    </span>
                                  </div>
                                  <div class="text-dark mb-1 px-2">
                                    <!-- <b>{{
                                    $t("Discount") +
                                    " " +
                                    checkPromotionItem(coupon)
                                  }}</b> -->
                                    <b>
                                      {{ $t( coupon.promotion.name) }}
                                    </b>
                                  </div>
                                  <div class="text-dark mb-2 px-2">
                                    {{ getDiscriptionCoupon(coupon) }}
                                  </div>
                                  <div
                                    class="text-secondary pt-2 px-2"
                                    style="font-size: 11px; border-top: 1px dashed #ddd;"
                                  >
                                    {{
                                      $t("Valid Until") +
                                        ": " +
                                        formatDate(coupon.coupon_config.start_date) +
                                        " - " +
                                        formatDate(coupon.coupon_config.end_date)
                                    }}
                                  </div>
                                </div>
                              </div>
                              <div
                                v-if="!coupon.canUse && coupon.tenantUse"
                                class="text-secondary"
                                style="font-size: 11px"
                              >
                                <i class="fa-light fa-circle-info" />
                                {{ $t("Coupon has applied to this tenant.") }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- \Coupon -->
                      <div class="py-2 border-bottom">
                        <dl class="h6">
                          <dd>{{ $t("Sub Total") }}</dd>
                          <dt>฿{{ ordersSummary.subTotal | formatNumber }}</dt>
                        </dl>
                        <dl class="h6">
                          <dd v-if="selectCouponCode.length">
                            {{ $t("Discount") }} {{ "(" + selectCouponCode + ")" }}
                          </dd>
                          <dd v-else>
                            {{ $t("Discount") }}
                          </dd>
                          <dt>฿{{ ordersSummary.discount | formatNumber }}</dt>
                        </dl>
                        <dl 
                          v-if="ordersSummary.discountOnTop > 0"
                          class="h6"
                        >
                          <dd>
                            {{ nameOnTop }}
                          </dd>
                          <dt>฿{{ ordersSummary.discountOnTop | formatNumber }}</dt>
                        </dl>
                        <dl class="h6">
                          <dd>{{ $t("Vat 7%") }}</dd>
                          <dt>฿{{ ordersSummary.vat | formatNumber }}</dt>
                        </dl>
                        <dl
                          class="h6"
                          v-if="orders.isRequestWithholdingTax"
                        >
                          <dd>{{ $t("Withholding") }} ({{ orders.WithholdingTax }}%)</dd>
                          <dt>฿{{ ordersSummary.withholdingTax | formatNumber }}</dt>
                        </dl>
                      </div>
                      <div class="py-2 border-bottom">
                        <dl class="h5 mb-0">
                          <dd>{{ $t("Grand Total") }}</dd>
                          <dt>
                            ฿{{ ordersSummary.grandTotal | formatNumber }}
                          </dt>
                        </dl>
                      </div>
                    </div>
                    <div class="card-footer bg-transparent border-0">
                      <!-- <div class="align-items-center d-flex justify-content-between mb-2">
                        <button
                          @click="goBack()"
                          class="btn btn-light btn-lg"
                          style="min-width: 145px;"
                        >
                          <i class="fa-solid fa-circle-arrow-left mr-2" />
                          {{ $t('Go Back') }}
                        </button>
                        <button
                          @click="printQuotation()"
                          class="btn btn-outline-primary btn-lg text-capitalize"
                        >
                          <i class="fa fa-print mr-2" />
                          {{ $t('พิมพ์ใบเสนอราคา') }}
                        </button>
                      </div> -->
                      <Ladda
                        v-if="ordersSummary.grandTotal > 0"
                        @click="purchasePlan()"
                        :text="$t('Purchase')"
                        :btn-class="'btn-lg btn-block btn-primary  mr-2'"
                        :loading="loading"
                        icon="<i class='fa-solid fa-cart-shopping'></i>"
                      />
                      <Ladda
                        v-else
                        @click="confirmPlan()"
                        :text="$t('Confirm')"
                        :btn-class="'btn-lg btn-block btn-primary  mr-2'"
                        :loading="loading"
                        icon="<i class='fas fa-check-circle'></i>"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-if="showQrCode">
          <div class="modal-body">
            <PayWithQrCode 
              :payAmount="ordersSummary.grandTotal" 
              :order-data="orderData"
            />
          </div>
        </template>
        <template v-if="showBankTransfer">
          <div class="modal-body">
            <PayWithBankTransfer
              :pay-amount="ordersSummary.grandTotal"
              :order-data="orderData"
            />
          </div>
        </template>
      </div>

      <div
        v-if="isSelectAddress"
        class="modal-content"
        style="color: #333;"
      >
        <div class="modal-header bg-dark">
          <h6 class="modal-title">
            {{ $t("Select Address") }}
          </h6>
          <span
            aria-hidden="true"
            class="close pointer"
            @click="cancelAddress()"
          >
            &times;
          </span>
        </div>

        <div class="modal-body pt-0">
          <PlaceholderContent
            is-load="true"
            v-if="isLoading"
          />
          <div
            v-else
            class="pb-5"
          >
            <div class="mx-n3">
              <legend class="font-weight-semibold h6 px-3 d-flex justify-content-between">
                <div>
                  <i class="fa-solid fa-location-check mr-2" />
                  {{ $t("Receipt Address") }}
                </div>
                <div
                  class="font-size-base"
                >
                  <div
                    @click="openBusinessInfo()"
                    class="pointer text-primary"
                  >
                    {{ $t("Manage Address") }}
                  </div>
                </div>
              </legend>
            </div>
            <div
              v-for="address in locationData"
              :key="`address-${address.id}`"
              @click="selectLocation(address.id)"
              :class="[
                'd-flex align-content-start border  mt-2 px-3 py-2 rounded-xl pointer',
                address.id == dataDefault ? ' border-primary' : '',
              ]"
            >
              <div class="form-check">
                <label class="form-check-label">
                  <div
                    :class="[
                      'uniform-choice',
                      address.id == dataDefault ? 'text-primary border-primary' : '',
                    ]"
                  >
                    <span
                      :class="[
                        address.id == dataDefault ? 'checked' : '',
                      ]"
                    >
                      <input
                        type="radio"
                        name="check-payment"
                        class="form-check-input-styled-primary"
                        :checked="[
                          address.id == dataDefault ? 'checked' : ''
                        ]"
                      >
                    </span>
                  </div>
                </label>
              </div>

              <div class="mx-2 w-100">
                <dl class="row mb-0">
                  <dt class="col-2">
                    {{ $t("Fullname") }}:
                  </dt>
                  <dd class="col-10">
                    {{ address.name }}
                  </dd>
                  <dt class="col-2">
                    {{ $t("Address") }}:
                  </dt>
                  <dd class="col-10">
                    {{ address.address1 }}, {{ address.county }},
                    {{ address.city }}, {{ address.state }},
                    {{ address.postcode }}
                  </dd>
                  <dt class="col-2">
                    {{ $t("Phone") }}:
                  </dt>
                  <dd class="col-10">
                    {{ address.telephone1 }}
                  </dd>
                  <dt class="col-2">
                    {{ $t("Tax ID") }}:
                  </dt>
                  <dd class="col-10">
                    <span v-if="address.tax_type == 'personal'">{{ address.tax_identification | isNull }}</span>
                    <span v-else>{{ address.business_tax | isNull }}</span>
                  </dd>
                  <dt class="col-2">
                    {{ $t("Apply To") }}:
                  </dt>
                  <dd class="col-10">
                    <template v-if="address.location_defaults">
                      <span>
                        <span
                          v-for="locationDefault in address.location_defaults"
                          class="mr-2 mb-1 d-inline-block"
                        >
                          <span
                            v-if="locationDefault.type.name == 'store'"
                            class="badge bg-success-400"
                          >
                            <i class="fas fa-star mr-1" />
                            {{ $t("Store Address") }}
                          </span>
                          <span
                            v-else-if="
                              locationDefault.type.name == 'billing'
                            "
                            class="
                              badge badge-flat
                              border-success
                              text-success-600
                            "
                          >
                            <i class="fas fa-file-alt mr-1" />
                            {{ $t("Billing Address") }}
                          </span>
                          <span
                            v-else-if="
                              locationDefault.type.name == 'shipping'
                            "
                            class="
                              badge badge-flat
                              border-success
                              text-success-600
                            "
                          >
                            <i class="fas fa-truck mr-1" />
                            {{ $t("Shipping Address") }}
                          </span>
                          <span
                            v-else
                            class="
                              badge badge-flat
                              border-success
                              text-success-600
                            "
                          >
                            <i class="fas fa-truck mr-1" />{{
                              $t(
                                "Apply To " + locationDefault.type.name
                              )
                            }}
                          </span>
                        </span>
                      </span>
                    </template>
                  </dd>
                </dl>
              </div>
            </div>
            <a
              href="#"
              class="text-primary btn-block mt-2"
            >
              <!-- <i
                v-if="endPage == 'loading'"
                class="icon-spinner2 spinner mr-2"
              /> -->
              <i
                class="mi-keyboard-arrow-down mr-2"
              />
              <span>{{ $t('See More') }}</span>
            </a>
            <div class="fixed-bottom bg-light border-top text-center py-2">
              <button
                type="button"
                class="btn btn-primary mr-2"
                @click="submitAddress()"
              >
                <i class="fas fa-save mr-1" />{{ $t("Save") }}
              </button>
              <button
                type="button"
                class="btn btn-light"
                @click="cancelAddress()"
              >
                {{ $t("Cancel") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal-success
      v-if="isModalSuccess"
      :order-number="orderNumber"
    />
  </div>
</template>

<script>
import Api from "@/services/endpoint/tenant.service";
import CentralApi from "@/services/endpoint/central.service.js";
import numeral from "numeral";
import Ladda from "@/plugins/Ladda.vue";
import PaymentMethod from "./PaymentMethod.vue";
import TaxInvoice from "./TaxInvoice.vue";
import PlaceholderContent from "@/plugins/PlaceholderContent.vue";
import AccessDenied from "@/components/tenancy/admin/error-page/templates/AccessDenied.vue";
import { convertTimezone } from "@/common/tenancy/convertTimezone";
import moment from "moment";
// import { required } from "vuelidate/lib/validators";
import ModalSuccess from "./ModalSuccess.vue"
import Cookies from "js-cookie";
import WebSocket from "isomorphic-ws"
import PayWithQrCode from "../../PayWithQrCode.vue"
import PayWithBankTransfer from "../../PayWithBankTransfer.vue"

export default {
  components: {
    Ladda,
    PaymentMethod,
    TaxInvoice,
    PlaceholderContent,
    AccessDenied,
    ModalSuccess,
    PayWithQrCode,
    PayWithBankTransfer
    // required
  },
  props: {
    tenantId : {
      type: Number,
      default: 0
    },
  },
  computed: {
    userId(){
      const user = this.$store.state.user;
      return user.user.global_id;
    }
  },
  created: async function () {
  },
  filters: {
    formatNumber(value) {
      if (!value) value = 0;
      return numeral(value).format("0,0.00");
    },
    formatNumberNotZero(value) {
      if (!value) value = 0;
      return numeral(value).format("0,0");
    },
    isNull: function (value) {
      if (value) {
        return value;
      }
      return "-";
    },
  },
  data() {
    return {
      tenant: JSON.parse(Cookies.get('tenant')),
      loading: false,
      hasPermission: false,
      paymentMethod: "PROMTPAY_QRCODE",
      couponCode: "",
      discountValue: 0,
      isSearching: false,
      showQrCode: false,
      showBankTransfer: false,
      isSelectAddress: false,
      locationData: [],
      locationDataSelect: {},
      locationDataSelectReciept: {},
      locationDataSelectWithholdingTax: {},
      keyLocation: 'locationDataSelect',
      isLoading: false,
      plan: null,
      plans: {},
      mainPlanSerie: {},
      selectPlan: {},
      ordersSummary: {
        grandTotal: 0
      },
      orderPromotionType: "Plan subscription",
      action: "change",
      orders: {
        method: 'QR Promptpay',
        isRequestReciept: false,
        isRequestWithholdingTax: false,
        isRequestTax: false,
        WithholdingTax: null,
        WithholdingTaxId: null,
      },
      coupons: [],
      loadUseTenantCoupons: [],
      selectCoupon: null,
      dataDefault: null,
      defaultRecieptAddress: null,
      oldRecieptAddress: null,
      defaultWithholdingTaxAddress: null,
      oldWithholdingTaxAddress: null,
      keyDefault: null,
      keyOld: null,
      perPage: 0,
      endPage: false,
      bankTransferForm: {
        bank_amount: "",
        bank_account_transferor: "",
        media: [],
      },
      limitImage: 1,
      limitImageSize: 1,
      checkingSlip: false,
      submitted_formDeposit: false,
      isInvalid: true,
      invalidCoupon: false,
      responseCouponMessage: "",
      usedCoupon: false,
      selectCouponCode: '',
      isClearCouponCode: false,
      isModalSuccess: false,
      defaultDiscounts: [
        {
          month: 1,
          percentDiscount: 0
        },
        {
          month: 3,
          percentDiscount: 5
        },
        {
          month: 6,
          percentDiscount: 10
        },
        {
          month: 12,
          percentDiscount: 15
        }
      ],
      discountV2: [],
      onTop: [],
      onTopDiscount: null,
      couponsV2: [],
      nameOnTop: '',
      promotionCoupon: [],
      timestamp: moment(),
      paymentMethodData: [],
      imageData: [],
      orderData: {},
      paymentId: null,
    };
  },
  watch: {
    selectCoupon(nwVal, oldVal) {
      this.calculateOrdersSummary();
    },
    selectPlan(nwVal, oldVal) {
      this.calculateOrdersSummary();
    },
    couponCode: {
      handler(val) {
        this.isClearCouponCode = false;
        this.invalidCoupon = false;
        this.usedCoupon = false;
      },
      deep: true,
    },
    '$parent.isLoading'(nwVal, oldVal) {
      if (nwVal === false) {
        this.feedData();
      }
    }
  },
  methods: {
    async feedData(previousPlan = null,planSeriesId = null) {
      try {
        let queryString = "";
        this.isLoading = true;
        if (this.$parent.isLoading) {
          return
        }
        this.paymentMethod = "PROMTPAY_QRCODE";
        this.showBankTransfer = false;
        this.selectCoupon = null;
        // console.log('previousPlan',planSeriesId)
        let dataForm = {
          "plan_serie_id": planSeriesId,
        };
        if (dataForm) {
            queryString += "?" + $.param(dataForm);
        }
        let response = await Api.SubscriptionV2.getPlansCreate(queryString);
        if (response.status != 200 && response.status != 201) {
          throw response;
        }
        this.discountV2 = response.data.standardDiscounts && response.data.standardDiscounts.length > 0 ? response.data.standardDiscounts.find((item) => item.promotion_group_name == 'Website’s Step Discount') : [];
        this.onTop = response.data.standardDiscounts && response.data.standardDiscounts.length > 0 ? response.data.standardDiscounts.filter((item) => item.promotion_group_name == 'On Top Subscription') : [];
        this.timestamp = response.data.timestamp;
        let discount = null;
        let discountPercent = null;
        let couponId = null;
        let genCoupon = null;
        let dataOnTop = {};
        if(this.onTop && this.onTop.length > 0){
          this.onTop.forEach((items) => {
            if(!items.gen_coupon){
              let onTopDiscount = items.config.find((item) => item.reference == 'Company'); //Sales Company
              if(onTopDiscount.slug == 'VOUCHER_DISCOUNT_CASH'){
                if(discount == null || discount.setting[0].get < onTopDiscount.setting[0].get){
                  couponId = items.id;
                  genCoupon = items.gen_coupon;
                  discount = onTopDiscount;
                }
                dataOnTop.discount = discount
                dataOnTop.couponId = couponId
                dataOnTop.genCoupon = genCoupon

                this.onTopDiscount = dataOnTop;
                this.nameOnTop = items.name;
              }else if(onTopDiscount.slug == 'BUY_DAY_GET_PERCENT'){
                if(discountPercent == null){
                  couponId = items.id;
                  genCoupon = items.gen_coupon;
                  discountPercent = onTopDiscount;
                }else{
                  onTopDiscount.setting.forEach(onTopDiscount => {
                    discountPercent.setting.find((discount) => {
                      if(discount.buy == onTopDiscount.buy && discount.get < onTopDiscount.get){
                        discount.get = onTopDiscount.get;
                        couponId = items.id;
                        genCoupon = items.gen_coupon;
                        return discount
                      }
                    });
                  });
                }
                dataOnTop.discount = discount
                dataOnTop.couponId = couponId
                dataOnTop.genCoupon = genCoupon
                
                this.onTopDiscount = dataOnTop;
                this.nameOnTop = items.name;
              }
            }
          });
        }if (response.data && response.data.payment_method) {
          let paymentMethods = [];
          response.data.payment_method.map((method, index) => {
            if (method.code == "QR-CODE" || method.code == "PROMTPAY_QRCODE") {
              paymentMethods.push({ ...method, code: "PROMTPAY_QRCODE", id: 1 });
            } else if (method.code == "CREDIT-DEBIT" || method.code == "CREDIT_DEBIT_CARD") {
              paymentMethods.push({ ...method, code: "CREDIT_DEBIT_CARD", id: 2 });
            } else if (method.code == "BANK-TRANFER" || method.code == "BANK_TRANSFER") {
              paymentMethods.push({ ...method, code: "BANK_TRANSFER", id: 3 });
            } else {
              paymentMethods.push({ ...method, id: index + 1 });
            }
          })

          this.paymentMethodData = paymentMethods.slice().sort((a, b) => a.id - b.id);;
        }
        // this.paymentMethodData = response.data.payment_method;
        this.locationData = response.data.address;
        this.loadCouponV2(response.data.coupons);
        this.loadPlanV2(response.data.data);
        this.loadSelectAddress();
        if (response.data.withholdingTax) {
          this.orders.WithholdingTax = numeral(response.data.withholdingTax.percent).format("0,0");
          this.orders.WithholdingTaxId = response.data.withholdingTax.id;
        }
        this.hasPermission = true;
      } catch (error) {
        console.log('error',error)
        this.hasPermission = false;
      }
      // this.getLocation();
      // this.getWithholdingTax();
      if (!this.hasPermission) {
        this.isLoading = false;
        return;
      }
      // await this.loadCoupon();
      // await this.loadPlan(previousPlan);
      this.isLoading = false;
    },
    formatNumber(value) {
      if (!value) value = 0;
      return numeral(value).format("0,0.00");
    },
    async selectPlans(plan) {
      if(plan){
        this.selectPlan = plan;
        // let dataPlan = JSON.parse(this.selectPlan.data);
        let dataPlan = this.selectPlan.data;
        let priceVat = this.selectPlan.price * 7 / 100;
        let price = this.selectPlan.price + priceVat;
        this.orders.subscriptions = [
          {
            slug: this.selectPlan.slug,
            quantity: 1,
            price_before_vat: this.selectPlan.price,
            price_vat: priceVat,
            price: price,
            sub_total_before_vat: this.selectPlan.price,
            sub_total_vat: priceVat,
            sub_total: price,
            discount_before_vat: 0,
            discount_vat: 0,
            discount: 0,
            total_before_vat: this.selectPlan.price,
            total_vat: priceVat,
            total: price
          }
        ];
        if (dataPlan.free_app_slugs) {
          var self = this;
          dataPlan.free_app_slugs.forEach(function(value, index) {
            self.orders.subscriptions.push({
              slug: value,
              quantity: 1,
              price_before_vat: 0,
              price_vat: 0,
              price: 0,
              sub_total_before_vat: 0,
              sub_total_vat: 0,
              sub_total: 0,
              discount_before_vat: 0,
              discount_vat: 0,
              discount: 0,
              total_before_vat: 0,
              total_vat: 0,
              total: 0
            })
          });
        }
        if(this.selectPlan.promotion){
          this.orders.promotion = this.selectPlan.promotion;
        }
        this.checkCounponMinSubscriptionDay();
        this.defaultCoupon();
      }
    },
    checkCounponMinSubscriptionDay() {
      let daysPlan = 0;
      let toDay = moment(convertTimezone.localToUtc()).format("YYYY-MM-DD HH:mm:ss'");
      if (this.selectPlan.invoice_interval == 'month') {
        daysPlan = this.selectPlan.invoice_period * 30;
      }
      this.coupons = [...this.coupons].map(coupon => {
        if(coupon.coupon_config.start_date > toDay){
          coupon.canUse = false;
        }else{
          coupon.promotion.config.find((item) => {
            if(item.reference == coupon.reference){
              coupon.canUse = false;
              let checkCoupon = item.setting.find((data) => data.buy == daysPlan);
              switch (item.slug) {
                case 'BUY_DAY_GET_PERCENT':
                  if(checkCoupon != undefined){
                    coupon.canUse = true;
                  }
                break;
                case 'BUY_DAY_GET_DAY':
                  if(checkCoupon != undefined){
                    coupon.canUse = true;
                  }
                break;
                case 'VOUCHER_DISCOUNT_CASH':
                  coupon.canUse = true;
                break;
                case 'VOUCHER_DISCOUNT_PERCENT':
                  coupon.canUse = true;
                break;
              }
            }
          });
        }
        return coupon
      })
      return;
    },
    selectPaymentMethod(pId) {
      this.paymentMethod = pId;
      if(this.paymentMethod == "BANK_TRANSFER") {
        this.orders.method = 'Bank Transfer';
      }else if(this.paymentMethod == "CREDIT_DEBIT_CARD") {
        this.orders.method = 'Credit Card';
      }else if(this.paymentMethod == "PROMTPAY_QRCODE") {
        this.orders.method = 'QR Promptpay';
      }
    },
    async searchCoupon() {
      this.isSearching = true;
      if (this.couponCode) {
        try{
          let dataForm = {
            "coupon": this.couponCode,
          };
          let response = await Api.PlanSubscriptionV2.postCouponV2(dataForm);
          if(response.status != 200 && response.status != 201){
            throw response;
          }
          //payload ค่าคูปองที่รับมา
          //ใส่คูปองใหม่แล้วกดยืนยัน
          this.coupons.push(response.data.data);
          this.loadCouponV2(this.coupons);
          this.selectPlans(this.selectPlan);
          this.defaultCoupon();
          this.applyDefaultCoupon(response.data.data);
          this.couponCode = "";
          this.usedCoupon = true;
          this.invalidCoupon = false;
          this.isSearching = false;
        } catch(error) {
          console.log('error',error)

          if(error.data.message){
            if(error.data.message == 'This coupon has been collected.'){
              let checkCoupon = this.coupons.find((data) => data.coupon_code == this.couponCode);
              if(checkCoupon && checkCoupon.canUse){
                this.selectCoupon = checkCoupon.id;
                this.orders.customer_coupon_id = checkCoupon.id;
                this.invalidCoupon = false;
                this.usedCoupon = true;
              }else{
                this.invalidCoupon = true;
                this.usedCoupon = false;
                this.responseCouponMessage = error.data.message;
              }
            }else{
              this.invalidCoupon = true;
              this.usedCoupon = false;
              if(error.data.message == 'The selected coupon not exists.'){
                this.responseCouponMessage = 'Coupon code not found.'
              }else if(error.data.message == 'The selected coupon has expired.'){
                this.responseCouponMessage = 'The selected coupon has expired.'
              }else if(error.data.message.includes('Valid until : {date}')){
                let data = error.data.message.split('/');
                let text = this.$t(data[0]);
                text = text.replace('{date}', moment(convertTimezone.utcToLocal(data[1])).format("YYYY-MM-DD"));
                this.responseCouponMessage = text;
              }else{
                this.responseCouponMessage = error.data.message;
              }
            }
          }
          this.isSearching = false;
        }
      }
      this.isClearCouponCode = true;
    },
    closeModal() {
      if(this.$refs.billing_preferences != undefined) {
        this.$refs.billing_preferences.clearData();
      }
      $("#modal_pay_for_plan").modal('hide');
      this.isSelectAddress = false;
      this.showQrCode = false;
      this.showBankTransfer = false;
      this.loading = false;
      this.submitted_formDeposit = false;
      this.invalidCoupon = false;
      this.usedCoupon = false;
      this.couponCode = "";
      this.isClearCouponCode = false;
      this.plan = null;
      this.locationDataSelect = {};
      this.locationDataSelectReciept = {};
      this.locationDataSelectWithholdingTax = {};
      this.locationData = [];
      this.dataDefault = null;
      this.orders.isRequestWithholdingTax = false;
      this.imageData = [];
    },
    async confirmPlan(type=null) {
      try {
      this.loading = true;
      let fileData = [];
      this.imageData.forEach((item) => {
        // let fileType = item.name.split('.').filter(Boolean).pop();
        // let fileName = item.name.replace('.' + fileType, '');
        fileData.push(item.path)
      });
      this.setupBillingAddress();

      if((this.orders.isRequestWithholdingTax || this.orders.isRequestTax) && (this.orders.tax_id == null || this.orders.tax_id.length != 13)){
        self.loading = false;
        return;
      }
      let payload = {
        subscriptions: this.orders.subscriptions,
        sub_total: this.orders.sub_total,
        discount_before_vat: this.orders.discount_before_vat,
        discount_vat: this.orders.discount_vat,
        discount: this.orders.discount,
        total_before_vat: this.orders.total_before_vat,
        total_vat: this.orders.total_vat,
        total_withholding_tax: this.orders.total_withholding_tax,
        total: this.orders.total,
        method: 'CENTRAL_FREE',
        fullname: this.orders.fullname,
        telephone1: this.orders.telephone1,
        address1: this.orders.address1,
        county: this.orders.county,
        city: this.orders.city,
        state: this.orders.state,
        postcode: this.orders.postcode,
        // print_quotation: type == 'Quotation' ? true : false,
        withholding_tax_file: fileData.length > 0 ? fileData : null
      };
      if(this.promotionCoupon.length > 0){
        let dataForm = {
          promotions: this.promotionCoupon,
        }
        Object.assign(payload, dataForm);
      }else{
        if(this.orders.promotion.length > 0){
          let dataForm = {
            promotions: this.orders.promotion,
          }
          Object.assign(payload, dataForm);
        }
      }
      if(this.orders.isRequestWithholdingTax){
        let dataForm = {
          withholding_tax_id: this.orders.WithholdingTaxId,
        }
        Object.assign(payload, dataForm);
      }
      this.orders.customer_coupon_id ? payload.customer_coupon_id = this.orders.customer_coupon_id : '';
      this.orders.telephone2 ? payload.telephone2 = this.orders.telephone2 : '';
      this.orders.address2 ? payload.address2 = this.orders.address2 : '';
      this.orders.email ? payload.email = this.orders.email : '';
      this.orders.tax_id ? payload.tax_id = this.orders.tax_id : '';
      this.orders.company ? payload.company = this.orders.company : '';
      // this.orders.isRequestReciept ? payload.is_request_reciept = this.orders.isRequestReciept : '';
      this.orders.isRequestTax ? payload.is_request_tax = this.orders.isRequestTax : '';
      this.orders.isRequestWithholdingTax ? payload.request_withholding_tax = this.orders.isRequestWithholdingTax : '';
      let response = await Api.SubscriptionV2.postPlansCreate(payload);
        if (response.status != 200 && response.status != 201) {
          throw response;
        }
        // if(type == 'Quotation'){
        //   return
        // }
        // this.orderNumber = res.data.data.order_number;
        this.isModalSuccess = true;
        // this.$parent.setParams();
        this.submitted_formDeposit = false;
        this.$toastr.s(this.$t('Purchase Plan Success.'),"<span class='fa-sharp fa-solid fa-circle-check'></span>" + this.$t("Success"));
      
      // await Api.SubscriptionV2.postCreate(payload)
      // .then((res) => {
      //   // this.closeModal();
      //   this.orderNumber = res.data.data.order_number;
      //   this.isModalSuccess = true;
      //   this.$parent.feedData();
      //   this.submitted_formDeposit = false;
      //   this.$toastr.s(this.$t('Purchase Plan Success.'),"<span class='t-icon icon-checkmark3'></span>" + this.$t("Success"));
      // })
      // .catch((error) => {
      //   console.log(error, 'error');
      //   if (error.response && error.response.data.message == "There is an order waiting for admin approval.") {
      //     this.submitFailPendingOrder();
      //   } else {
      //     this.$toastr.w(this.$t(error.response.data.message), "<span class='icon-warning22'></span>" + this.$t("Warning"));
      //     this.loading = false;
      //   }
      // });

      this.loading = false;

        
      } catch (error) {
        console.log(error, 'error');
        if (error.data.message && error.data.message == "There is an order waiting for admin approval.") {
          this.submitFailPendingOrder();
          this.loading = false;
        } else {
          this.$toastr.w(this.$t("Purchase Plan Failed."),"<span class='fa-solid fa-circle-check mr-2'></span>" + this.$t("Failed"));
          this.loading = false;
        }
      }
    },
    submitFailPendingOrder() {
      this.$swal({
        icon: "warning",
        iconColor: "#FF7043",
        title: this.$t("Unable to Purchase")+'!',
        // text: "You won’t be able to undo this action.",
        html: this.$t("You have an order pending approval. Please contact the admin to proceed."),
        showCancelButton: true,
        confirmButtonText:
          '<i class="fas fa-check-circle mr-1"></i>' + this.$t("Got It"),
        buttonsStyling: false,
        showCancelButton: false,
        customClass: {
          confirmButton: "btn btn-primary mr-2",
          cancelButton: "btn btn-light",
        },
        focusConfirm: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          // try {
          //   this.$parent.feedData();
          //   this.closeModal();
          //   // this.$router.push({
          //   //   name: "t.a.premium.subscriptions",
          //   // });
          // } catch(err) {
          //   console.log(err, 'push t.a.premium.subscriptions')
          // }

          // this.$toastr.e(this.$t('Purchase Plan Failed.'),"<span class='icon-blocked'></span>" + this.$t("Failed"));
        }
      });
    },
    async purchasePlan(type=null) {
      try {
        this.loading = true;
        const self = this;
        // this.$nextTick(function () {
        //   this.loading = true;
        // });

        let fileData = [];
        this.imageData.forEach((item) => {
          // let fileType = item.name.split('.').filter(Boolean).pop();
          // let fileName = item.name.replace('.' + fileType, '');
          fileData.push(item.path)
        });
        this.submitted_formDeposit = true;
        // if(this.isInvalid && this.paymentMethod == "BANK-TRANFER"){
        //   if(this.bankTransferForm.media.length == 0){

        //     document.getElementById("payWithBankTransfer").scrollIntoView({ behavior: "smooth" });
        //     this.$toastr.e(
        //       this.$t('Please attach proof of payment slip.'),
        //       "<span class='icon-warning22'></span>" +
        //         this.$t("Failed")
        //     );
        //   }
        //   setTimeout(function () {
        //     self.$nextTick(function () {
        //       self.loading = false;
        //     });
        //   }, 1000);

        //   return;
        // }

        // this.orders.order_payment.paid = this.ordersSummary.grandTotal;
        this.setupBillingAddress();
        if((this.orders.isRequestWithholdingTax || this.orders.isRequestTax) && (this.orders.tax_id == null || this.orders.tax_id.length != 13)){
          self.loading = false;
          return;
        }
        let payload = {
          subscriptions: this.orders.subscriptions,
          sub_total: this.orders.sub_total,
          discount_before_vat: this.orders.discount_before_vat,
          discount_vat: this.orders.discount_vat,
          discount: this.orders.discount,
          total_before_vat: this.orders.total_before_vat,
          total_vat: this.orders.total_vat,
          total_withholding_tax: this.orders.total_withholding_tax,
          total: this.orders.total,
          method: this.orders.method,
          fullname: this.orders.fullname,
          telephone1: this.orders.telephone1,
          address1: this.orders.address1,
          county: this.orders.county,
          city: this.orders.city,
          state: this.orders.state,
          postcode: this.orders.postcode,
          // print_quotation: type == 'Quotation' ? true : false,
          withholding_tax_file: fileData.length > 0 ? fileData : null
        };
        if(this.promotionCoupon.length > 0){
          let dataForm = {
            promotions: this.promotionCoupon,
          }
          Object.assign(payload, dataForm);
        }else{
          if(this.orders.promotion.length > 0){
            let dataForm = {
              promotions: this.orders.promotion,
            }
            Object.assign(payload, dataForm);
          }
        }
        if(this.orders.isRequestWithholdingTax){
          let dataForm = {
            withholding_tax_id: this.orders.WithholdingTaxId,
          }
          Object.assign(payload, dataForm);
        }
        this.orders.customer_coupon_id ? payload.customer_coupon_id = this.orders.customer_coupon_id : '';
        this.orders.telephone2 ? payload.telephone2 = this.orders.telephone2 : '';
        this.orders.address2 ? payload.address2 = this.orders.address2 : '';
        this.orders.email ? payload.email = this.orders.email : '';
        this.orders.tax_id ? payload.tax_id = this.orders.tax_id : '';
        this.orders.company ? payload.company = this.orders.company : '';
        // this.orders.isRequestReciept ? payload.is_request_reciept = this.orders.isRequestReciept : '';
        this.orders.isRequestTax ? payload.is_request_tax = this.orders.isRequestTax : '';
        this.orders.isRequestWithholdingTax ? payload.request_withholding_tax = this.orders.isRequestWithholdingTax : '';
        this.orders.payments = [];
        
        let response = await Api.SubscriptionV2.postPlansCreate(payload);
        if (response.status != 200 && response.status != 201) {
          throw response;
        }
        this.orderData = response.data.data;
        if(response.data.data.payment_method == 'PROMTPAY_QRCODE'){
          this.paymentId = response.data.data.id;
          this.showQrCode = true;
        }else if(response.data.data.payment_method == 'BANK_TRANSFER'){
          this.submitted_formDeposit = false;
          this.showBankTransfer = true;
        }else if(response.data.data.payment_method == 'CREDIT_DEBIT_CARD'){
          window.open(this.orderData.redirect_to, '_blank').focus();
          this.submitted_formDeposit = false;
          this.closeModal();
        }
        this.loading = false;
        // if(type == 'Quotation'){
        //   return
        // }
        // if (this.paymentMethod == "QR-CODE") {
        //   this.showQrCode = true;
        // } else if (this.paymentMethod == "BANK-TRANFER") {
        //   this.showBankTransfer = true;
        //     // if(this.bankTransferForm.media.length > 0){
        //     //   let attachments = [];
        //     //   attachments.push(this.bankTransferForm.media[0].path);
        //     //   this.orders.payments.push({
        //     //     bank: 'KBANK',
        //     //     bank_name: 'Kasikornbank',
        //     //     account: '1141056499',
        //     //     account_holder: 'Goship Company Ltd.',
        //     //     amount: this.bankTransferForm.bank_amount,
        //     //     attachments: attachments
        //     //   });
        //     //   payload.payments = this.orders.payments;

        //     //   setTimeout(async function(){
        //     //     await Api.SubscriptionV2.postCreate(payload)
        //     //     .then((res) => {
        //     //       self.$toastr.s(self.$t('Purchase Plan Success.'),"<span class='t-icon icon-checkmark3'></span>" + self.$t("Success"));
        //     //       self.orderNumber = res.data.data.order_number;
        //     //       self.isModalSuccess = true;
        //     //       self.submitted_formDeposit = false;
        //     //     })
        //     //     .catch((error) => {
        //     //       if (
        //     //         error.response &&
        //     //         error.response.data.message ==
        //     //           "There is an order waiting for admin approval."
        //     //       ) {
        //     //         self.submitFailPendingOrder();
        //     //       } else if (error.response && error.response.data && error.response.data.message) {
        //     //         self.$toastr.w(
        //     //           self.$t(error.response.data.message),
        //     //           "<span class='icon-warning22'></span>" + self.$t("Warning")
        //     //         );
        //     //       } else {
        //     //         console.error(error);
        //     //       }
        //     //       self.loading = false;
        //     //     });
        //     //   }, 150);
        //     // }else{
        //     //   this.$nextTick(function () {
        //     //     this.loading = false;
        //     //   });
        //     // }
        // } else if (this.paymentMethod == "CREDIT-DEBIT") {
        //   payload.method = this.orders.method = 'CENTRAL_CREDIT_CARD';

        //   setTimeout(async function(){
        //     try{
        //         let successUrl = window.location.origin+'/app/2c2p/callback/success';
        //         let failedUrl = window.location.origin+'/app/2c2p/callback/failed';
        //         self.orders.payments.push({
        //           gateway: '2c2p',
        //           amount: self.orders.total
        //         });
        //         payload.payments = self.orders.payments;
        //         payload.successUrl = successUrl;
        //         payload.failedUrl = failedUrl;
        //         const billingOrder = await Api.SubscriptionV2.postCreate(payload);

        //         if(billingOrder.data.data){
        //           let billingOrderData = billingOrder.data.data;
        //           let invoiceNo = billingOrderData.order_number;
        //           let amount = billingOrderData.total;
        //           let description = self.$t('Purchase Subscription Plan');
        //           let amountCredit = amount;
        //           let currencyCode = 'THB';

        //           let formDataCredit = new FormData();
        //           formDataCredit.append('invoiceNo', invoiceNo);
        //           formDataCredit.append('description', description);
        //           formDataCredit.append('amount', amountCredit);
        //           formDataCredit.append('currencyCode', currencyCode);
        //           formDataCredit.append('langCode', 'TH');
        //           formDataCredit.append('userDefined1', self.tenant.merchant);
        //           formDataCredit.append('successUrl', successUrl);
        //           formDataCredit.append('failedUrl', failedUrl);

        //           let addcreditcard = await Api.Wallet.addCreditCard(formDataCredit);
        //           if(addcreditcard.data.data.status && addcreditcard.data.data.respCode == "0000"){
        //             self.openWebsocket()
        //             window.open(addcreditcard.data.data.webPaymentUrl, '_blank').focus();
        //             self.submitted_formDeposit = false;
        //             self.closeModal();
        //           }
        //         }
        //     } catch(error) {
        //       console.log(error)
        //       if (
        //         error.response &&
        //         error.response.data.message ==
        //           "There is an order waiting for admin approval."
        //       ) {
        //         self.submitFailPendingOrder();
        //       } else if (error.response && error.response.data && error.response.data.message) {
        //         self.$toastr.w(
        //           self.$t(error.response.data.message),
        //           "<span class='icon-warning22'></span>" + self.$t("Warning")
        //         );
        //       } else {
        //         console.error(error);
        //       }
        //       self.loading = false;
        //     };
        //   }, 150);
        // }
      } catch (error) {
        console.log(error, 'error');
        if (error.data.message && error.data.message == "There is an order waiting for admin approval.") {
          this.submitFailPendingOrder();
          this.loading = false;
        } else {
          this.$toastr.w(this.$t("Purchase Plan Failed."),"<span class='fa-solid fa-circle-check mr-2'></span>" + this.$t("Failed"));
          this.loading = false;
        }
      }
    },
    // async getWithholdingTax(){
    //     let calculateWithholdingTax = await CentralApi.WithholdingTax.getWithholdingTax();
    //     if (calculateWithholdingTax.data) {
    //         this.orders.WithholdingTax = numeral(calculateWithholdingTax.data.data.percent).format("0,0");
    //         this.orders.WithholdingTaxId = calculateWithholdingTax.data.data.id;
    //     }
    // },
    // async getLocation(){
    //     // this.perPage = this.perPage + 25;
    //     // this.endPage = 'loading';
    //     // let location = await Api.Location.getLocation("?per_page="+this.perPage);
    //     // if (location.data) {
    //     //     this.locationData = location.data.data;
    //     //     let meta = location.data.meta;
    //     //     this.endPage = meta.current_page == meta.last_page;
    //     // }
    // },
    async loadSelectAddress(type = null) {
      this.keyDefault = 'dataDefault';
      this.keyOld = '';
      this.keyLocation = 'locationDataSelect';
      // if(type == 'isRequestReciept') {
        // this.keyDefault = 'defaultRecieptAddress';
        // this.keyOld = 'oldRecieptAddress';
        // this.keyLocation = 'locationDataSelectReciept';
      // } else if(type == 'isRequestWithholdingTax') {
        // this.keyDefault = 'defaultWithholdingTaxAddress';
        // this.keyOld = 'oldWithholdingTaxAddress';
        // this.keyLocation = 'locationDataSelectWithholdingTax';
      // }
      this[this.keyLocation] = this.locationData.find(this[this.keyDefault] == null ? (element) => element.location_defaults.find((element2) => element2.type.name === "billing") : (element) => element.id == this[this.keyDefault]);
      if(this[this.keyDefault] == null && this[this.keyLocation]) {
        this[this.keyDefault] = this[this.keyLocation].id;
      } else {
        this[this.keyOld] = this[this.keyDefault];
      }
      return;
    },
    loadPlanV2(plan){
      let planSlug = null;
      // let plans = plan;
      this.plans = plan.map(item => {
        let discount = 0;
        let defaultDiscount = 0;
        let percentDiscount = 0;
        let discountOnTop = 0;
        let defaultDiscountOnTop = 0;
        let percentDiscountOnTop = 0;
        let promotion = [];
        let standardDiscounts = null;
        if(this.discountV2){
          standardDiscounts = this.discountV2.config.find((discount) => discount.reference == "Company");
          // let onTop = this.onTop.config.find((onTop) => onTop.reference == "Company");
        }
          if(item.invoice_interval == 'month'){
            if(standardDiscounts){
              if(standardDiscounts.slug == 'BUY_DAY_GET_PERCENT'){
                let buy = item.invoice_period * 30;
                defaultDiscount = standardDiscounts.setting.find((items) => items.buy == buy);
                if(defaultDiscount != undefined){
                  discount = item.price * (defaultDiscount.get / 100);
                  percentDiscount = defaultDiscount.get
                  promotion.push({
                    "promotion_id": this.discountV2.id,
                    "original_price": item.price,
                    "ordered_quantity": 1,
                    "discount": discount,
                    "discounted_price": item.price - discount,
                    "gen_coupon": this.discountV2.gen_coupon
                  });
                }
              }else if(standardDiscounts.slug == 'VOUCHER_DISCOUNT_CASH'){
                discount = standardDiscounts.setting[0].get;
                promotion.push({
                  "promotion_id": this.discountV2.id,
                  "original_price": item.price,
                  "ordered_quantity": 1,
                  "discount": discount,
                  "discounted_price": item.price - discount,
                  "gen_coupon": this.discountV2.gen_coupon
                });
              }
            }
            if(this.onTopDiscount){
              if(this.onTopDiscount.discount.slug == 'BUY_DAY_GET_PERCENT'){
                let buy = item.invoice_period * 30;
                defaultDiscountOnTop = this.onTopDiscount.discount.setting.find((items) => items.buy == buy);
                if(defaultDiscountOnTop != undefined){
                  let price = item.price - discount;
                  discountOnTop = price * (defaultDiscountOnTop.get / 100);
                  percentDiscountOnTop = defaultDiscountOnTop.get
                  promotion.push({
                    "promotion_id": this.onTopDiscount.couponId,
                    "original_price": item.price - discount,
                    "ordered_quantity": 1,
                    "discount": discountOnTop,
                    "discounted_price": item.price - discount - discountOnTop,
                    "gen_coupon": this.onTopDiscount.genCoupon
                  });
                }
              }else if(this.onTopDiscount.discount.slug == 'VOUCHER_DISCOUNT_CASH'){
                discountOnTop = this.onTopDiscount.discount.setting[0].get;
                promotion.push({
                  "promotion_id": this.onTopDiscount.couponId,
                  "original_price": item.price - discount,
                  "ordered_quantity": 1,
                  "discount": discountOnTop,
                  "discounted_price": item.price - discount - discountOnTop,
                  "gen_coupon": this.onTopDiscount.genCoupon
                });
              }
            }
            return {
              ...item,
              discount: discount,
              percent_discount: percentDiscount,
              discountOnTop: discountOnTop,
              percentDiscountOnTop: percentDiscountOnTop,
              discount_default_price: item.price - discount - discountOnTop,
              promotion: promotion
            }
          }
        
        
      });

      if(planSlug){
        this.mainPlanSerie = this.plans.find(
          (element) => element.slug == planSlug
        );
      }else{
        this.mainPlanSerie = this.plans.find(
          (element) => element.invoice_period == 1
        );
      }
      this.selectPlans(this.mainPlanSerie);
      return;
    },
    async loadPlan(previousPlan = null) {
      let planSerieId = null;
      let planSlug = null;
      if(this.plan){
        planSerieId = this.plan.plan_series_id;
        planSlug = this.plan.slug;
      }else{
        let response = await CentralApi.Tenant.getPlanSubscription(this.tenant.id,{ dataReady: true });
        let standardPlan = response.standardPlanSubscription;
        planSerieId = standardPlan.plan.plan_series_id;
        if(previousPlan){
          planSerieId = previousPlan.plan_series_id;
          planSlug = previousPlan.plan_slug;
        }
      }

      let param = {
        notFree: 1,
        planSerieId: planSerieId,
      };
      let queryString = "";

      if (param) {
        queryString += "?" + $.param(param);
      }
      let plans = await CentralApi.Plan.getPlan(queryString, {
        dataReady: true,
      });
      let self = this;
      this.plans = await plans.map(item => {
        let discount = 0;
        let defaultDiscount = 0;
        if (item.invoice_period >= 3) {
          defaultDiscount = self.defaultDiscounts.find((defaultDiscount) => defaultDiscount.month == item.invoice_period);
          discount = item.price * (defaultDiscount.percentDiscount / 100);
        }
        return {
          ...item,
          discount: discount,
          percent_discount: defaultDiscount.percentDiscount? defaultDiscount.percentDiscount: 0,
          discount_default_price: item.price - discount
        }
      });
      // this.mainPlanSerie = this.plans.find(
      //   (element) => element.invoice_period == 1
      // );
      if(planSlug){
        this.mainPlanSerie = this.plans.find(
          (element) => element.slug == planSlug
        );
      }else{
        this.mainPlanSerie = this.plans.find(
          (element) => element.invoice_period == 1
        );
      }
      this.selectPlans(this.mainPlanSerie);
      return;
    },
    loadCouponV2(data){
      this.coupons = data;
      this.coupons.map((item) => {
        item.canUse = true;
      });
    },
    // async loadCoupon() {
      // let coupons = await CentralApi.Coupon.getCoupon('?notRefer=true', {
      //   dataReady: true,
      // });
      // let tenantId = this.tenant.id;
      // let loadUseTenantCoupons = await CentralApi.Tenant.getPromotionItemCoupon(
      //   tenantId,
      //   {
      //     dataReady: true,
      //   }
      // );
      // this.loadUseTenantCoupons = loadUseTenantCoupons;
      // let couponLength = coupons.length;
      // for (let i = 0; i < couponLength; i++) {
      //   let useTenantCoupon = this.loadUseTenantCoupons.find(
      //     (loadUseTenantCoupon) =>
      //       loadUseTenantCoupon.id === coupons[i].promotion_item_coupon.id
      //   );
      //   if (useTenantCoupon) {
      //     coupons[i].canUse = false;
      //     coupons[i].tenantUse = true;
      //   } else {
      //     coupons[i].canUse = true;
      //     coupons[i].tenantUse = false;
      //   }
      // }
      // coupons.sort(function (a, b) {
      //   return b.canUse - a.canUse;
      // });
      // this.coupons = coupons;
      // return;
    // },
    defaultCoupon() {
      if (this.coupons.length > 0) {
        let defaultCoupon = null;
        let discouponCoupon = 0;
        this.coupons.forEach((coupon) => {
          let discount = 0;
          if(coupon.canUse){
            discount = this.calculateDiscount(coupon);
          }
          if (discount > discouponCoupon) {
            discouponCoupon = discount;
            defaultCoupon = coupon;
          }
        });
        if (defaultCoupon) {
          if (this.checkPromotionTypePlanSubscription(defaultCoupon) && defaultCoupon.canUse) {
            this.selectCoupon = defaultCoupon.id;
            this.orders.customer_coupon_id = defaultCoupon.id;
            let promotionCoupon = [];
            promotionCoupon.push({
              "promotion_id" : defaultCoupon.promotion.id,
              "original_price" : this.selectPlan.price,
              "ordered_quantity" : 1,
              "discount" : discouponCoupon,
              "discounted_price" : this.selectPlan.price - discouponCoupon,
              "gen_coupon" : defaultCoupon.promotion.gen_coupon
            });
            this.promotionCoupon = promotionCoupon;
            return;
          }
        }
      }
      this.selectCoupon = null;
      return;
    },
    applyDefaultCoupon(couponCode){
      if (this.coupons.length > 0) {
        let defaultCoupon = null;
        let coupon = this.coupons.find(
          (coupons) => coupons.coupon_code == couponCode.coupon_code
        );

        let discouponCoupon = 0;
        let discount = 0;
        //เข้าสู่การคำนวนคูปองตามเงืท่อนไขต่างๆ โดยคำนวนทุกคูปอง
        discount = this.calculateDiscount(coupon);

        if (discount > discouponCoupon) {
          discouponCoupon = discount;
          defaultCoupon = coupon;
        }

        if (defaultCoupon) {
          if (this.checkPromotionTypePlanSubscription(defaultCoupon) && defaultCoupon.canUse) {
            this.selectCoupon = defaultCoupon.id;
            this.orders.customer_coupon_id = defaultCoupon.id;
            let promotionCoupon = [];
            promotionCoupon.push({
              "promotion_id" : defaultCoupon.promotion.id,
              "original_price" : this.selectPlan.price,
              "ordered_quantity" : 1,
              "discount" : discouponCoupon,
              "discounted_price" : this.selectPlan.price - discouponCoupon,
              "gen_coupon" : defaultCoupon.promotion.gen_coupon
            });
            this.promotionCoupon = promotionCoupon;
          }
        }
      }
      return;
    },
    selectLocation(id) {
      this[this.keyDefault] = id;
    },
    submitAddress() {
      this[this.keyLocation] = this.locationData.find(
        (element) => element.id == this[this.keyDefault]
      );
      this.isSelectAddress = false;
    },
    cancelAddress() {
      this[this.keyDefault] = this[this.keyOld];
      this[this.keyOld] = null;
      this.isSelectAddress = false;
    },
    checkPromotionTypePlanSubscription(coupon) {
      let promotionType = coupon.promotion.type.name;
      if (promotionType === "Plan Subscription") {
        return true;
      }
      return false;
    },
    // getMinimumOrdersCoupon(coupon) {
    //   let minSubscriptionDay = coupon.promotion_item_coupon.promotion_item.promotion.min_subscription_day;
    //   if (minSubscriptionDay > 0) {
    //     return (
    //       this.$t("minimum") +
    //       " " +
    //       minSubscriptionDay +
    //       " " +
    //       this.$t("days")
    //     );
    //   }
    //   return this.$t("No Minimum");
    // },
    getDiscriptionCoupon(coupon){
      let discriptionCoupon = coupon.promotion.description;
      if (discriptionCoupon == null || discriptionCoupon == '') {
        return '';
      }
      return discriptionCoupon;
    },
    calculateOrdersSummary() {
      this.selectCouponCode = '';
      let coupon = this.coupons.find((coupon) => coupon.id === this.selectCoupon);
      // let onTop = this.standardDiscounts.find((coupon) => coupon.id === this.selectCoupon);
      this.ordersSummary.discount = 0;
      let subTotal = this.selectPlan.price;
      let discount = this.selectPlan.discount;
      let discountOnTop = this.selectPlan.discountOnTop;
      if (coupon) {
        discountOnTop = 0;
        discount = this.calculateDiscount(coupon);
        this.selectCouponCode = coupon.coupon_code;
      } else {

      }
      this.ordersSummary.subTotal = subTotal;
      this.ordersSummary.discount = discount;
      this.ordersSummary.discountOnTop = discountOnTop;

      const orderedPlanSubscriptoin = this.orders.subscriptions.find(subscription => subscription.slug === this.selectPlan.slug);

      orderedPlanSubscriptoin.discount_before_vat = orderedPlanSubscriptoin.discount = discount;

      let grandTotalBeforeVat = subTotal - discount - discountOnTop;
      let vat = (grandTotalBeforeVat * 7) / 100;
      let withholdingTax = this.orders.isRequestWithholdingTax ? parseFloat(((grandTotalBeforeVat * this.orders.WithholdingTax) / 100).toFixed(2)) : 0;
      let grandTotal = (grandTotalBeforeVat + vat) - withholdingTax;
      this.ordersSummary.vat = vat;
      this.ordersSummary.withholdingTax = withholdingTax;
      this.ordersSummary.grandTotal = grandTotal.toFixed(2);

      this.orders.total_before_vat = orderedPlanSubscriptoin.total_before_vat = parseFloat((subTotal - discount - discountOnTop).toFixed(2));
      this.orders.total_vat = orderedPlanSubscriptoin.total_vat = parseFloat((orderedPlanSubscriptoin.total_before_vat * 7 / 100).toFixed(2));
      this.orders.total = this.orders.sub_total = orderedPlanSubscriptoin.total = parseFloat(((orderedPlanSubscriptoin.total_before_vat + orderedPlanSubscriptoin.total_vat) - withholdingTax).toFixed(2));
      this.orders.discount_before_vat = discount + discountOnTop;
      this.orders.discount_vat = 0;
      this.orders.discount = discount + discountOnTop;
      this.orders.total_withholding_tax = withholdingTax;
      // console.log('total',this.orders.total)
      // this.orders.method = this.orders.total == 0 ? 'CENTRAL_FREE' : this.orders.method;
    },
    formatDate(date) {
      var formattedDate = moment(convertTimezone.utcToLocal(date)).format(
        "DD-MM-YYYY"
      );
      return formattedDate;
    },
    clickCoupon(coupon) {
      if (this.checkPromotionTypePlanSubscription(coupon) && coupon.canUse) {
        if (this.selectCoupon == coupon.id) {
          this.selectCoupon = null;
          this.promotionCoupon = [];
          delete this.orders.customer_coupon_id;
        } else {
          this.selectCoupon = coupon.id;
          this.orders.customer_coupon_id = coupon.id;
          this.calculateDiscount(coupon,'clickCoupon');
        }
      }
    },
    setupBillingAddress() {
      let billingAddress = this.locationDataSelect;
      // if(
        // this.orders.isRequestReciept && Object.keys(this.locationDataSelectReciept).length > 0 ||
        // (this.orders.isRequestWithholdingTax || this.orders.isRequestTax) && Object.keys(this.locationDataSelectWithholdingTax).length > 0
      // ) {
        // billingAddress = this.locationDataSelectWithholdingTax;
        // billingAddress = this.orders.isRequestReciept ? this.locationDataSelectReciept : this.locationDataSelectWithholdingTax;
      // }
      let taxId = null;
      let billingCompany = null;
      if (billingAddress.tax_type == "personal") {
          taxId = billingAddress.tax_identification;
      } else if (billingAddress.tax_type == "business") {
          taxId = billingAddress.business_tax;
          billingCompany = billingAddress.business_name;
      }
      this.orders.fullname = billingAddress.name;
      this.orders.telephone1 = billingAddress.telephone1;
      this.orders.telephone2 = billingAddress.telephone2;
      this.orders.email = billingAddress.email;
      this.orders.address1 = billingAddress.address1;
      this.orders.address2 = billingAddress.address2;
      this.orders.county = billingAddress.county;
      this.orders.city = billingAddress.city;
      this.orders.state = billingAddress.state;
      this.orders.postcode = billingAddress.postcode;
      this.orders.tax_id = taxId;
      this.orders.company = billingCompany;
    },
    openWebsocket(){
      let vm = this
      let ws = this.websocket = new WebSocket(process.env.WEBSOCKETS_GOQUEUE_URL);
      // Open websocket
      let merchantId = this.$store.state.user.tenant.merchant;

      ws.onopen = function open() {
        ws.send(JSON.stringify({
          "data": {
            "clientUid": `payment.events${merchantId}`
          },
          "event": "subscribe"
        }));

        vm.$parent.intervalIdPing = setInterval(() => {
          ws.send(JSON.stringify({
            "data": {
              "clientUid": `payment.events${merchantId}`
            },
            "event": "ping"
          }));
        }, 10000);
      };

      ws.onclose = function close() {
        clearInterval(this.$parent.intervalIdPing);
        console.log('disconnected');
      };

      // Action websocket
      ws.onmessage = function incoming(message) {
        let data = JSON.parse(message.data)
        if (data.data.clientUid == `payment.events${merchantId}` && data.event == `payment.events`) {
          let paylaod = data.data;
          if (paylaod.status) {
            vm.$toastr.s(vm.$t("Purchase Plan Success."), "<span class='t-icon icon-checkmark3'></span>" + vm.$t("Success"));
          } else {
            vm.$toastr.e(vm.$t("Purchase Plan Failed."), "<span class='icon-blocked'></span>" + vm.$t('Failed'));
          }
          vm.websocket = null;
          clearInterval(vm.$parent.intervalIdPing);
        }
      }
    },
    clearDataCoupon(){
      this.couponCode = "";
      this.isClearCouponCode = false;
      this.invalidCoupon = false;
      this.usedCoupon = false;
    },
    openBusinessInfo: function () {
      this.$refs.close.click();
      this.$nextTick( () => {
        this.$router.push({ name: "t.a.settings.business-info" });
      });
    },
    calculateDiscount(coupon,functionName=null){
      let discount = 0;
      
      let defaultCoupons = coupon.promotion.config.find((coupons) => coupons.reference == coupon.reference);
      if(defaultCoupons != undefined){
        if(this.selectPlan.invoice_interval == 'month'){
          let buy = this.selectPlan.invoice_period * 30;
          let defaultDiscount = defaultCoupons.setting.find((items) => items.buy == buy);
          if(defaultCoupons.slug == 'BUY_DAY_GET_PERCENT'){
            if(defaultDiscount != undefined){
              discount = this.selectPlan.price * (defaultDiscount.get / 100);
            }
          }else if(defaultCoupons.slug == 'BUY_DAY_GET_DAY'){
            if(defaultDiscount != undefined){
              discount = (this.selectPlan.price / buy) * defaultDiscount.get;
            }
          }else if(defaultCoupons.slug == 'VOUCHER_DISCOUNT_CASH'){
            discount = defaultCoupons.setting[0].get;
          }else if(defaultCoupons.slug == 'VOUCHER_DISCOUNT_PERCENT'){
            discount = this.selectPlan.price * (defaultCoupons.setting[0].get  / 100);
          }

          if(functionName == 'clickCoupon' && discount > 0){
            this.promotionCoupon = [];
            this.promotionCoupon.push({
              "promotion_id" : coupon.promotion.id,
              "original_price" : this.selectPlan.price,
              "ordered_quantity" : 1,
              "discount" : discount,
              "discounted_price" : this.selectPlan.price - discount,
              "gen_coupon" : coupon.promotion.gen_coupon
            });

          }
          return discount;
        }
      }
      

    },
    goBack(){

    },
    printQuotation(){
      try {
        let Swal = this.$swal;
        let self = this;
        Swal({
          icon: "warning",
          iconColor: "#FF7043",
          title: self.$t("พิมพ์ใบเสนอราคา") + "?",
          html: self.$t("ระบบจะทำการสร้างคำสั่งซื้อ คุณจะต้องทำการชำระเงินบนประวัติสั่งซื้อภายใน 7 วัน หากเกินกำหนด ระบบจะทำการยกเลิกคำสั่งซื้ออัตโนมัติ"),
          showCancelButton: true,
          cancelButtonText: self.$t("Cancel"),
          confirmButtonText: '<i class="fas fa-check-circle mr-1"></i> ' + self.$t("Confirm"),
          buttonsStyling: false,
          customClass: {
            confirmButton: "btn btn-primary mr-2",
            cancelButton: "btn btn-light",
          },
          focusConfirm: false,
          showLoaderOnConfirm: true,
          preConfirm: async () => {
            if(this.ordersSummary.grandTotal > 0){
              this.purchasePlan('Quotation');
            }else{
              this.confirmPlan('Quotation');
            }
          },
        });
      } catch (error) {
        console.log(error);
      }
    },
    async resetQrCode(){
      try {
        this.isLoading = true;
        this.showQrCode = false;
        let response = {};
        response = await Api.SubscriptionV2.getPayment(this.paymentId);
        if (response.status != 200 && response.status != 201) {
          throw response;
        }
        this.orderData = response.data.data;
        if(response.data.data.payment_method == 'PROMTPAY_QRCODE'){
          this.showQrCode = true;
        }
        this.isLoading = false;
      } catch (error) {
        console.log('error ==> ',error)
        // if (error.status == 403) {
        //   this.isLoading = false;
        //   return;
        // }
        // this.comingSoon = false;
        // return;

      }
    },

  },
  beforeDestroy() {
    if (this.websocket) {
      this.websocket.close();
    }
  }
};
</script>

<style scoped>
span.select-plan {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 18px 18px;
  border-color: transparent transparent #007bff transparent;
}

span.select-plan > i,
span.select-plan > span {
  position: absolute;
  right: 2px;
  top: 9px;
  font-size: 7px;
  color: #fff;
}

.bg-light-f6f6f6 {
  background-color: #f6f6f6 !important;
  color: inherit !important;
}

.step-num {
  height: 24px;
  width: 24px;
  font-weight: normal;
  text-align: center;
  padding: 0;
  line-height: 24px;
  background: #333;
  color: #fff;
  border-radius: 100%;
}

.table th {
  border-top: 0;
}

dl {
  display: flex;
  align-items: start;
  justify-content: space-between;
}

dl dt,
dl dd {
  margin-bottom: 0;
}

.searching {
  display: inline-block;
  width: 15px;
  height: 15px;
  border: 1px solid rgba(255, 255, 255, 1);
  border-radius: 50%;
  border-top-color: #888;
  animation: spin 1s ease-in-out infinite;
  -webkit-animation: spin 1s ease-in-out infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}

span.select-coupon {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 0 0 18px 18px;
  border-color: transparent transparent #007bff transparent;
}

span.select-coupon > i {
  position: absolute;
  right: 2px;
  top: 9px;
  font-size: 7px;
  color: #fff;
}
.bg-blue-custom{
  background: #F1F9FF;
}

</style>



// WEBPACK FOOTER //
// src/components/tenancy/admin/account-setting/premium-subscriptions/payment-modal/ModalPayForPlan.vue